import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom'
import App from './app';

const Root = ({ store }) => {
  return (
    <Provider store={ store }>
      <Router>
        <App />
      </Router>
    </Provider>
  );
};

export default Root;



// WEBPACK FOOTER //
// ./frontend/components/root.jsx